import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";

export const useActivityAvailabilityPastDaysLimit = (): number => {
  const {
    data: { availability }
  } = useMyAccountInfo();

  const { activity_availability_past_days_limit: activityAvailabilityPastDaysLimit } = availability || {};

  return activityAvailabilityPastDaysLimit ?? 0;
};
